import angular from "angular";

angular
    .module('app')
    .component('videoSelectModal', {
        template: require('./video-select-modal.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = 9;
    $ctrl.search = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.getList();
    };

    $ctrl.getList = function () {

        if ($ctrl.course) {
            $ctrl.course_id = $ctrl.course.id;
        }
        $http
            .get('/admin/videos/get-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    search: $ctrl.search,
                    course_id: $ctrl.course_id,
                }
            })
            .then(
                function (response) {
                    $ctrl.videos = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {

                }
            );
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.resetFilter = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.selectVideo = function (video) {
        if (confirm('Are  you sure to select video?')) {
            $ctrl.close({$value: video});
        }
    };

}
